import React from 'react';
import PreviewRenderer from './PreviewRenderer';

const RightPanel = ({ 
  pageData, 
  updateComponent, 
  onComponentClick, 
  selectedComponentId,
  onExport, 
  onSave 
}) => {
  return (
    <section className="builder-canvas">
      <header className="builder-canvas-header">
        <div>
          <h3>Live Preview</h3>
          <p>Click on any component to edit its properties</p>
        </div>
        <div className="builder-canvas-actions">
          <button type="button" className="btn-secondary" onClick={onExport}>
            Export Config
          </button>
          <button type="button" className="btn-primary" onClick={onSave}>
            Save Page
          </button>
        </div>
      </header>
      <div className="builder-canvas-area">
        <PreviewRenderer 
          components={pageData.components}
          layoutId={pageData.layoutId}
          themeId={pageData.themeId}
          onComponentClick={onComponentClick}
          selectedComponentId={selectedComponentId}
          isProductionMode={true}
        />
      </div>
    </section>
  );
};

export default RightPanel;
